var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"success-icon"},[_c('icon-check',{staticClass:"success-icon__char"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }